import { Injectable } from '@angular/core';
/**
 * Configuration service, provides default values for the AccordionComponent.
 */
var AccordionConfig = (function () {
    function AccordionConfig() {
        /** Whether the other panels should be closed when a panel is opened */
        this.closeOthers = false;
    }
    AccordionConfig.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    AccordionConfig.ctorParameters = function () { return []; };
    return AccordionConfig;
}());
export { AccordionConfig };
//# sourceMappingURL=accordion.config.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/ngx-bootstrap/accordion/accordion.config.js
// module id = ../../../../ngx-bootstrap/accordion/accordion.config.js
// module chunks = 4